// Animations standardisées réutilisables
export const standardVariants = {
  hidden: { 
    opacity: 0, 
    y: 15 
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  }
};

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.1
    }
  }
};

// Variante pour conteneur avec stagger personnalisé
export const createContainerVariants = (staggerChildren = 0.05, delayChildren = 0.1) => ({
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren,
      delayChildren
    }
  }
});

// Animation pour les éléments avec hover
export const hoverVariants = {
  hover: {
    scale: 1.02,
    transition: { duration: 0.2 }
  }
};

// Animation pour les éléments de liste
export const listItemVariants = {
  hidden: { 
    opacity: 0, 
    x: -10 
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  }
};